"use client";

interface YouTubePlayerProps {
  videoId: string;
  className?: string;
  title?: string;
}

export const YouTubePlayer = ({
  videoId,
  className = "",
  title = "YouTube video player",
}: YouTubePlayerProps) => {
  return (
    <div
      className={`rounded-xl shadow-xl overflow-hidden aspect-video ${className}`}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1`}
        className="w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </div>
  );
};
